import { CSSProperties, FC } from 'react'

import { clsx } from '@mantine/core'

import { HomeBannerItem } from '.'
import { HomeBannerImage } from './HomeBannerImage'

export type HomeBannerFooterProps = {
  banner: HomeBannerItem
  isMobile?: boolean
  style?: CSSProperties
  className?: string
}
export const HomeBannerFooter: FC<HomeBannerFooterProps> = (props) => {
  const { isMobile, banner, style, className } = props

  return (
    <HomeBannerImage
      banner={banner}
      bannerProps={{
        'data-event-category': 'Footer Banner',
        'data-event-action': 'Click',
        'data-event-label': banner.url,
      }}
      isMobile={isMobile}
      desktopRatio="auto"
      mobileRatio="auto"
      className={clsx('homeBannerFooter', className)}
      style={style}
    />
  )
}
